import { IRoute } from '@config/routes/interfaces';

export const AdminPaths: IRoute[] = [
    {
        path: '/admin/organisations',
        key: 'admin-organisations',
    },
    {
        path: '/admin/users',
        key: 'admin-user-accounts',
    },
    {
        path: '/admin/event-log',
        key: 'admin-event-log',
    },
    {
        path: '/admin/risks',
        key: 'admin-risks',
    },
    {
        path: '/admin/organisation/plugin',
        key: 'admin-organisation-plugin',
    },
    {
        path: '/admin/study/plugin',
        key: 'admin-study-plugin',
    },
    {
        path: '/admin/system/plugin',
        key: 'admin-system-plugin',
    },
    {
        path: '/admin/system/report-templates',
        key: 'admin-manage-report-templates',
    },
    {
        path: '/admin/system/snapshot',
        key: 'admin-system-snapshot',
    },
];

export const LoginPaths: IRoute[] = [
    {
        path: '/',
        key: 'info',
    },
    {
        path: '/login',
        key: 'login',
    },
    {
        path: '/2fa/:token/:phone/:orgCode',
        key: 'login-2fa-org',
    },
    {
        path: '/2fa/:token/:phone',
        key: 'login-2fa',
    },
    {
        path: '/login/:orgCode',
        key: 'login-organisation',
    },
    {
        path: '/reset/:token/:orgCode',
        key: 'password-reset-org',
    },
    {
        path: '/reset/:token',
        key: 'password-reset',
    },
    {
        path: '/forgot-password',
        key: 'forgot-password-admin',
    },
    {
        path: '/forgot-password/:orgCode',
        key: 'forgot-password',
    },
    {
        path: '/organisation/:organisationId/member/:memberId/accept',
        key: 'accept-org-invite',
    },
    {
        path: '/verify-email/:organisationKey/:userId',
        key: 'verify-email',
    },
];

export const PrivatePaths: IRoute[] = [
    {
        path: '/home',
        key: 'home',
    },
    {
        path: '/organisation/evaluation-models',
        key: 'manage-evaluation-models',
    },
    {
        path: '/organisation/risks',
        key: 'org-risk-library',
    },
    {
        path: '/organisation/roles',
        key: 'admin-org-roles',
    },
    {
        path: '/organisation/permissions/:roleId',
        key: 'admin-org-permissions-role-id',
    },
    {
        path: '/organisation/permissions',
        key: 'admin-org-permissions',
    },
    {
        path: '/organisation/users',
        key: 'admin-org-user-accounts',
    },
    {
        path: '/organisation/event-log',
        key: 'admin-org-event-log',
    },
    {
        path: '/organisation/panels',
        key: 'admin-org-panels',
    },
    {
        path: '/organisation/studies',
        key: 'admin-org-studies',
    },
    {
        path: '/organisation/indications',
        key: 'admin-org-indications',
    },
    {
        path: '/organisation/programs',
        key: 'admin-org-programs',
    },
    {
        path: '/organisation/products',
        key: 'admin-org-products',
    },
    {
        path: '/organisation/list-of-values',
        key: 'admin-org-lovs',
    },
    {
        path: '/central-monitoring/controls-hub',
        key: 'cm2-controls-hub',
    },
    {
        path: '/central-monitoring/study-hub',
        key: 'cm2-study-hub',
    },
    {
        path: '/central-monitoring/site-hub',
        key: 'cm2-site-hub',
    },
    {
        path: '/central-monitoring/dataset-hub',
        key: 'cm2-dataset-hub',
    },
    {
        path: '/central-monitoring/data-view/:dataView',
        key: 'cm2-data-views',
    },
    {
        path: '/central-monitoring/study-team',
        key: 'cm2-study-team',
    },
    {
        path: '/central-monitoring/reports',
        key: 'cm2-reports',
    },
    {
        path: '/central-monitoring/manage-signatories',
        key: 'cm2-manage-signatories',
    },
    {
        path: '/central-monitoring/generation-history',
        key: 'cm2-generation-history',
    },
    {
        path: '/legacy-central-monitoring/team',
        key: 'cm-study-team',
    },
    {
        path: '/legacy-central-monitoring/reports',
        key: 'cm-reports',
    },
    {
        path: '/legacy-central-monitoring/legacy-reports',
        key: 'cm-legacy-reports',
    },
    {
        path: '/legacy-central-monitoring/manage-signatories',
        key: 'cm-manage-signatories',
    },
    {
        path: '/legacy-central-monitoring/review-report',
        key: 'cm-review-report',
    },
    {
        path: '/legacy-central-monitoring/generation-history',
        key: 'cm-generation-history',
    },
    {
        path: '/legacy-central-monitoring/study-dashboard',
        key: 'cm-study-dashboard',
    },
    {
        path: '/legacy-central-monitoring/site-dashboard',
        key: 'cm-site-dashboard',
    },
    {
        path: '/legacy-central-monitoring/manage-observations',
        key: 'cm-manage-observations',
    },
    {
        path: '/legacy-central-monitoring/manage-actions',
        key: 'cm-manage-actions',
    },
    {
        path: '/subject-monitoring/subject-hub',
        key: 'sm-subject-hub',
    },
    {
        path: '/subject-monitoring/subject-profile',
        key: 'sm-subject-profile',
    },
    {
        path: '/subject-monitoring/study-team',
        key: 'sm-study-team',
    },
    {
        path: '/subject-monitoring/reports',
        key: 'sm-reports',
    },
    {
        path: '/subject-monitoring/manage-signatories',
        key: 'sm-manage-signatories',
    },
    {
        path: '/subject-monitoring/generation-history',
        key: 'sm-generation-history',
    },
    {
        path: '/study/members',
        key: 'manage-study-members',
    },
    {
        path: '/study/sm-members',
        key: 'manage-sm-study-members',
    },
    {
        path: '/study/panels',
        key: 'manage-study-panels',
    },
    {
        path: '/study/dashboard-setup',
        key: 'manage-study-dashboard',
    },
    {
        path: '/study/manage-hubs',
        key: 'manage-hubs',
    },
    {
        path: '/study/manage-panels',
        key: 'manage-panels',
    },
    {
        path: '/study/data-views',
        key: 'manage-data-views',
    },
    {
        path: '/study/site-dashboard-setup',
        key: 'manage-site-dashboard',
    },
    {
        path: '/study/extra-fields',
        key: 'manage-study-extra-data',
    },
    {
        path: '/study/data-review-setup',
        key: 'manage-study-data-review',
    },
    {
        path: '/study/manage-datasets',
        key: 'manage-study-datasets',
    },
    {
        path: '/study/cohorts',
        key: 'manage-study-cohorts',
    },
    {
        path: '/study/treatment-arms',
        key: 'manage-study-treatment-arms',
    },
    {
        path: '/study/subject-visit-schedules',
        key: 'manage-visit-schedules',
    },
    {
        path: '/study/data-processing-log',
        key: 'data-processing-log',
    },
    {
        path: '/study/crfs',
        key: 'manage-study-crfs',
    },
    {
        path: '/study/assessments',
        key: 'manage-study-assessments',
    },
    {
        path: '/study/settings',
        key: 'manage-study-settings',
    },
    {
        path: '/dummy-components',
        key: 'dummy-components-page',
    },
    {
        path: '/user/profile',
        key: 'user-profile',
    },
    {
        path: '/admin/audit-log',
        key: 'audit-log',
    },
    {
        path: '/organisation/excel-listing',
        key: 'admin-org-excel-listing',
    },
    {
        path: '/organisation/report-templates',
        key: 'admin-org-report-templates',
    },
    {
        path: '/risk-assessment/critical-to-quality-factors',
        key: 'ra-critical-to-quality-factors',
    },
    {
        path: '/risk-assessment/risk-log',
        key: 'ra-risk-log',
    },
    {
        path: '/risk-assessment/risk-log/id/:id',
        key: 'ra-risk-log-filter-id',
    },
    {
        path: '/risk-assessment/risk-log/impact/:impact+/ltd/:ltd',
        key: 'ra-risk-log-filter-impact-ltd',
    },
    {
        path: '/risk-assessment/risk-log/category/:category+/rating/:rating',
        key: 'ra-risk-log-filter-category-rating',
    },
    {
        path: '/risk-assessment/risk-log/review-status/:reviewStatus',
        key: 'ra-risk-log-filter-review-status',
    },
    {
        path: '/risk-assessment/risk-log/cm-control-chart/:studyId/:chartId',
        key: 'ra-risk-log-cmcontrol-chart-popout',
    },
    {
        path: '/risk-assessment/risk-dashboard',
        key: 'ra-risk-dashboard',
    },
    {
        path: '/data-quality',
        key: 'data-quality-nav',
    },
    {
        path: '/risk-assessment/reporting',
        key: 'ra-reports',
    },
    {
        path: '/risk-assessment/manage-signatories',
        key: 'ra-manage-signatories',
    },
    {
        path: '/risk-assessment/generation-history',
        key: 'ra-generation-history',
    },
    {
        path: '/risk-assessment/excel-listing',
        key: 'ra-excel-listing',
    },
    {
        path: '/risk-assessment/study-team',
        key: 'ra-study-team',
    },
    {
        path: '/risk-assessment/risk-monitoring',
        key: 'ra-risk-monitoring',
    },
    {
        path: '/risk-assessment/cm-controls',
        key: 'ra-manage-cm-controls',
    },
    {
        path: '/organisation/subject-monitoring/manage-reviews',
        key: 'admin-org-sm-manage-reviews',
    },
    {
        path: '/subject-monitoring/manage-review-plans',
        key: 'sm-manage-review-plans',
    },
    {
        path: '/organisation/ram-dashboard',
        key: 'admin-org-ram-dashboard',
    },
    {
        path: '/organisation/manage-cm-integration',
        key: 'admin-org-manage-cm-integration',
    },
];

export const PublicPaths: IRoute[] = [
    {
        path: '/terms',
        key: 'terms',
    },
    {
        path: '/500',
        key: '/public/500',
    },
    {
        path: '*',
        key: '/public/404',
    },
];
